import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap';
import '../styles/variables.css';
import '../styles/components/footer.css';
import logo from '../images/logo.jpeg';
import {Link} from 'react-router-dom'

class Footer extends Component {
     render(){
         return(
             <div>
                <Row className="footer m-none">
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className="footer-container">
                            <div className="nav-brand shadow">
                                <div className="nav-title">
                                <img src={logo} alt="main-logo" className="main-logo"/>
                                    <p className="powered">Powered by: <b>LaPieza.io</b></p>
                                </div>
                            </div>
                            <div className="footer-links">
                                <Link className="footer-link" to="/management">Login para administradores</Link>
                                <Link className="footer-link" to="/company">Login para empresas</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className="copywrite m-none">
                    <p className="right">
                        Copywrite 2019.
                    </p>
                    <p className="right-l">
                        Powered by LaPieza.io
                    </p>
                </Row>
             </div>
         )
     }
}

export default Footer;